module.exports = __webpack_public_path__ + "img/asian-noodles-2.75c9c90b.jpg";